import $ from 'jquery';

$(function() {
    
    $('.wp-block-hoyry-bosch-service-list').each(function() {
        
        var $block = $(this);
        
        $block.find('service-filter').on('click', function() {
            
            var termSlug = $(this).attr('data-term-slug');
            
            $block.find('service-list').fadeOut(100, function() {
                
                $block.find('service-category').hide();
                $block.find('service-category.' + termSlug).show();
                
                $block.find('service-filter').removeClass('selected');
                $block.find('service-filter[data-term-slug="' + termSlug + '"]').addClass('selected');
                
                $block.find('service-list').fadeIn(100);
                
            })
            
            var queryParams = new URLSearchParams( window.location.search );
            queryParams.set( 'category', termSlug );
            history.replaceState( null, null, '?' + queryParams.toString() );
            
        }); 
        
    });
    
});